export const boardsViewTypes = {
  LIST: 'LIST',
  DASHBOARD: 'DASHBOARD',
};
